export const FONTREGULAR = "Poppins-Regular";
export const FONTBOLD = "Poppins-Bold";
export const FONTMEDIUM = "Poppins-Medium";
export const FONTSEMIBOLD = "Poppins-SemiBold";
